import React from "react";
import { ChatMessage } from "../hooks/useDocumentChat";

interface MessageBubbleProps {
  message: ChatMessage;
}

const MessageBubble: React.FC<MessageBubbleProps> = ({ message }) => {
  const isUser = message.role === "user";

  return (
    <div className={`flex gap-3 ${isUser ? "flex-row-reverse" : "flex-row"}`}>
      {/* Avatar */}
      <div className={`shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold
        ${isUser
          ? "bg-gray-200 text-gray-600"
          : "text-white"
        }`}
        style={!isUser ? { background: "linear-gradient(135deg,#7C3AED,#2563EB)" } : undefined}
      >
        {isUser ? "U" : (
          <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none">
            <line x1="12" y1="7" x2="12" y2="4.5" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
            <circle cx="12" cy="3.5" r="1.5" fill="white"/>
            <rect x="3.5" y="7" width="17" height="13" rx="3"
              fill="rgba(255,255,255,0.2)" stroke="white" strokeWidth="1.5"/>
            <circle cx="9" cy="13" r="1.5" fill="white"/>
            <circle cx="15" cy="13" r="1.5" fill="white"/>
            <path d="M9 17 Q12 18.5 15 17" stroke="white" strokeWidth="1.5" strokeLinecap="round" fill="none"/>
          </svg>
        )}
      </div>

      {/* Bubble */}
      <div className={`max-w-[78%] rounded-2xl px-4 py-3 text-sm leading-relaxed whitespace-pre-wrap
        ${isUser
          ? "bg-gray-100 text-gray-800 rounded-tr-sm"
          : "bg-white border border-gray-100 shadow-sm text-gray-800 rounded-tl-sm"
        }`}
      >
        {message.content}
      </div>
    </div>
  );
};

interface StreamingBubbleProps {
  content: string;
}

export const StreamingBubble: React.FC<StreamingBubbleProps> = ({ content }) => (
  <div className="flex gap-3 flex-row">
    <div className="shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-white"
      style={{ background: "linear-gradient(135deg,#7C3AED,#2563EB)" }}>
      <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none">
        <line x1="12" y1="7" x2="12" y2="4.5" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
        <circle cx="12" cy="3.5" r="1.5" fill="white"/>
        <rect x="3.5" y="7" width="17" height="13" rx="3"
          fill="rgba(255,255,255,0.2)" stroke="white" strokeWidth="1.5"/>
        <circle cx="9" cy="13" r="1.5" fill="white"/>
        <circle cx="15" cy="13" r="1.5" fill="white"/>
        <path d="M9 17 Q12 18.5 15 17" stroke="white" strokeWidth="1.5" strokeLinecap="round" fill="none"/>
      </svg>
    </div>
    <div className="max-w-[78%] rounded-2xl rounded-tl-sm px-4 py-3 text-sm leading-relaxed
      bg-white border border-gray-100 shadow-sm text-gray-800 whitespace-pre-wrap">
      {content || (
        <span className="flex gap-1 items-center h-5">
          <span className="w-1.5 h-1.5 rounded-full bg-gray-400 animate-bounce" style={{ animationDelay: "0ms" }}/>
          <span className="w-1.5 h-1.5 rounded-full bg-gray-400 animate-bounce" style={{ animationDelay: "150ms" }}/>
          <span className="w-1.5 h-1.5 rounded-full bg-gray-400 animate-bounce" style={{ animationDelay: "300ms" }}/>
        </span>
      )}
      {content && <span className="inline-block w-0.5 h-4 bg-gray-500 ml-0.5 align-middle animate-pulse"/>}
    </div>
  </div>
);

export default MessageBubble;
